import React from 'react';
import Avatar, { AvatarProps } from '@mui/material/Avatar';
import { useTheme } from '@mui/material';

interface StringAvatarProps extends AvatarProps {
  name: string;
}

export const StringAvatar = React.forwardRef<HTMLDivElement, StringAvatarProps>(
  ({ name, sx, color, ...props }, ref) => {
    const theme = useTheme();
    color = color ?? theme.palette.action.active;

    const splitNames = name.split(' ');
    let reducedName = '?';
    if (splitNames.length > 1) {
      reducedName = `${splitNames[0][0]}${splitNames[splitNames.length - 1][0]}`;
    } else if (splitNames[0].length > 1) {
      reducedName = `${splitNames[0][0]}${splitNames[0][1]}`;
    } else if (splitNames[0].length > 0) {
      reducedName = `${splitNames[0][0]}`;
    }

    return (
      <Avatar
        {...props}
        ref={ref}
        sx={{
          bgcolor: 'transparent',
          width: 28,
          height: 28,
          fontSize: 12,
          border: `1px solid ${color}`,
          color: color,
          ...sx,
        }}
      >
        <span>{reducedName}</span>
      </Avatar>
    );
  },
);
